import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { loginRequest, LoginCredentials, LoginResponse } from '@/api/auth';

export function useLogin() {
  return useMutation<LoginResponse, AxiosError<{ message?: string }>, LoginCredentials>({
    mutationFn: loginRequest,
  });
}
